/**
 * This function determines if a feature is enabled or not.
 */
export const isFeatureEnabled = ({ isFeatureEnabledExternally, isUrlFeatureFlagEnabled, isClaimsFeatureFlagEnabled, isInternalUser, isInternalOnly, }) => {
    // Internal feature behavior:
    if (isInternalOnly && !isInternalUser) {
        return false;
    }
    // Public feature behavior:
    return (isFeatureEnabledExternally ||
        isUrlFeatureFlagEnabled ||
        isClaimsFeatureFlagEnabled);
};
